/* eslint-disable */
!(function (t, e) {
  'object' == typeof module && 'object' == typeof module.exports
    ? (module.exports = t.document
        ? e(t, !0)
        : function (t) {
            if (!t.document)
              throw new Error('Cropper requires a window with a document');
            return e(t);
          })
    : e(t);
})('undefined' != typeof window ? window : this, function (t, e) {
  'use strict';
  function i(t) {
    return re.call(t).slice(8, -1).toLowerCase();
  }
  function a(t) {
    return 'number' == typeof t && !isNaN(t);
  }
  function n(t) {
    return 'undefined' == typeof t;
  }
  function o(t) {
    return 'object' == typeof t && null !== t;
  }
  function r(t) {
    var e, i;
    if (!o(t)) return !1;
    try {
      return (
        (e = t.constructor),
        (i = e.prototype),
        e && i && he.call(i, 'isPrototypeOf')
      );
    } catch (a) {
      return !1;
    }
  }
  function h(t) {
    return 'function' === i(t);
  }
  function l(t) {
    return G.isArray ? G.isArray(t) : 'array' === i(t);
  }
  function c(t, e) {
    return (e = e >= 0 ? e : 0), G.from ? G.from(t).slice(e) : le.call(t, e);
  }
  function s(t) {
    return (
      'string' == typeof t && (t = t.trim ? t.trim() : t.replace(Yt, '$1')), t
    );
  }
  function d(t, e) {
    var i, n;
    if (t && h(e))
      if (l(t) || a(t.length))
        for (n = 0, i = t.length; n < i && e.call(t, t[n], n, t) !== !1; n++);
      else if (o(t))
        for (n in t)
          if (t.hasOwnProperty(n) && e.call(t, t[n], n, t) === !1) break;
    return t;
  }
  function p(t) {
    var e;
    if (arguments.length > 1) {
      if (((e = c(arguments)), K.assign)) return K.assign.apply(K, e);
      e.shift(),
        d(e, function (e) {
          d(e, function (e, i) {
            t[i] = e;
          });
        });
    }
    return t;
  }
  function u(t, e) {
    var i = c(arguments, 2);
    return function () {
      return t.apply(e, i.concat(c(arguments)));
    };
  }
  function g(t, e) {
    var i = t.style;
    d(e, function (t, e) {
      Lt.test(e) && a(t) && (t += 'px'), (i[e] = t);
    });
  }
  function f(t, e) {
    return t.classList ? t.classList.contains(e) : t.className.indexOf(e) > -1;
  }
  function m(t, e) {
    var i;
    return a(t.length)
      ? d(t, function (t) {
          m(t, e);
        })
      : t.classList
      ? t.classList.add(e)
      : ((i = s(t.className)),
        void (i
          ? i.indexOf(e) < 0 && (t.className = i + ' ' + e)
          : (t.className = e)));
  }
  function v(t, e) {
    return a(t.length)
      ? d(t, function (t) {
          v(t, e);
        })
      : t.classList
      ? t.classList.remove(e)
      : void (
          t.className.indexOf(e) >= 0 &&
          (t.className = t.className.replace(e, ''))
        );
  }
  function w(t, e, i) {
    return a(t.length)
      ? d(t, function (t) {
          w(t, e, i);
        })
      : void (i ? m(t, e) : v(t, e));
  }
  function b(t, e) {
    return o(t[e])
      ? t[e]
      : t.dataset
      ? t.dataset[e]
      : t.getAttribute('data-' + e);
  }
  function x(t, e, i) {
    o(i) && n(t[e])
      ? (t[e] = i)
      : t.dataset
      ? (t.dataset[e] = i)
      : t.setAttribute('data-' + e, i);
  }
  function D(t, e) {
    o(t[e])
      ? delete t[e]
      : t.dataset
      ? delete t.dataset[e]
      : t.removeAttribute('data-' + e);
  }
  function C(t, e, i) {
    var a = s(e).split(kt);
    return a.length > 1
      ? d(a, function (e) {
          C(t, e, i);
        })
      : void (t.removeEventListener
          ? t.removeEventListener(e, i, !1)
          : t.detachEvent && t.detachEvent('on' + e, i));
  }
  function y(t, e, i, a) {
    var n = s(e).split(kt),
      o = i;
    return n.length > 1
      ? d(n, function (e) {
          y(t, e, i);
        })
      : (a &&
          (i = function () {
            return C(t, e, i), o.apply(t, arguments);
          }),
        void (t.addEventListener
          ? t.addEventListener(e, i, !1)
          : t.attachEvent && t.attachEvent('on' + e, i)));
  }
  function B(t, e, i) {
    var a;
    return t.dispatchEvent
      ? (h(Event) && h(CustomEvent)
          ? (a = n(i)
              ? new Event(e, { bubbles: !0, cancelable: !0 })
              : new CustomEvent(e, { detail: i, bubbles: !0, cancelable: !0 }))
          : n(i)
          ? ((a = F.createEvent('Event')), a.initEvent(e, !0, !0))
          : ((a = F.createEvent('CustomEvent')),
            a.initCustomEvent(e, !0, !0, i)),
        t.dispatchEvent(a))
      : t.fireEvent
      ? t.fireEvent('on' + e)
      : void 0;
  }
  function T(t) {
    t.preventDefault ? t.preventDefault() : (t.returnValue = !1);
  }
  function L(e) {
    var i,
      n = e || t.event;
    return (
      n.target || (n.target = n.srcElement || F),
      a(n.pageX) ||
        ((i = F.documentElement),
        (n.pageX =
          n.clientX +
          (t.scrollX || (i && i.scrollLeft) || 0) -
          ((i && i.clientLeft) || 0)),
        (n.pageY =
          n.clientY +
          (t.scrollY || (i && i.scrollTop) || 0) -
          ((i && i.clientTop) || 0))),
      n
    );
  }
  function X(e) {
    var i = F.documentElement,
      a = e.getBoundingClientRect();
    return {
      left:
        a.left +
        (t.scrollX || (i && i.scrollLeft) || 0) -
        ((i && i.clientLeft) || 0),
      top:
        a.top +
        (t.scrollY || (i && i.scrollTop) || 0) -
        ((i && i.clientTop) || 0)
    };
  }
  function Y(t) {
    var e = t.length,
      i = 0,
      a = 0;
    return (
      e &&
        (d(t, function (t) {
          (i += t.pageX), (a += t.pageY);
        }),
        (i /= e),
        (a /= e)),
      { pageX: i, pageY: a }
    );
  }
  function k(t, e) {
    return t.getElementsByTagName(e);
  }
  function E(t, e) {
    return t.getElementsByClassName
      ? t.getElementsByClassName(e)
      : t.querySelectorAll('.' + e);
  }
  function W(t) {
    return F.createElement(t);
  }
  function H(t, e) {
    t.appendChild(e);
  }
  function M(t) {
    t.parentNode && t.parentNode.removeChild(t);
  }
  function z(t) {
    for (; t.firstChild; ) t.removeChild(t.firstChild);
  }
  function O(t) {
    var e = t.match(Xt);
    return e && (e[1] !== V.protocol || e[2] !== V.hostname || e[3] !== V.port);
  }
  function R(t) {
    var e = 'timestamp=' + new Date().getTime();
    return t + (t.indexOf('?') === -1 ? '?' : '&') + e;
  }
  function N(t, e) {
    var i;
    return t.naturalWidth && !$t
      ? e(t.naturalWidth, t.naturalHeight)
      : ((i = W('img')),
        (i.onload = function () {
          e(this.width, this.height);
        }),
        void (i.src = t.src));
  }
  function U(t) {
    var e = [],
      i = t.rotate,
      n = t.scaleX,
      o = t.scaleY;
    return (
      a(n) && a(o) && e.push('scale(' + n + ',' + o + ')'),
      a(i) && e.push('rotate(' + i + 'deg)'),
      e.length ? e.join(' ') : 'none'
    );
  }
  function A(t, e) {
    var i,
      a,
      n = Jt(t.degree) % 180,
      o = ((n > 90 ? 180 - n : n) * ne) / 180,
      r = Qt(o),
      h = te(o),
      l = t.width,
      c = t.height,
      s = t.aspectRatio;
    return (
      e
        ? ((i = l / (h + r / s)), (a = i / s))
        : ((i = l * h + c * r), (a = l * r + c * h)),
      { width: i, height: a }
    );
  }
  function I(t, e) {
    var i,
      n,
      o,
      r = W('canvas'),
      h = r.getContext('2d'),
      l = 0,
      c = 0,
      s = e.naturalWidth,
      d = e.naturalHeight,
      p = e.rotate,
      u = e.scaleX,
      g = e.scaleY,
      f = a(u) && a(g) && (1 !== u || 1 !== g),
      m = a(p) && 0 !== p,
      v = m || f,
      w = s * Jt(u || 1),
      b = d * Jt(g || 1);
    return (
      f && ((i = w / 2), (n = b / 2)),
      m &&
        ((o = A({ width: w, height: b, degree: p })),
        (w = o.width),
        (b = o.height),
        (i = w / 2),
        (n = b / 2)),
      (r.width = w),
      (r.height = b),
      v && ((l = -s / 2), (c = -d / 2), h.save(), h.translate(i, n)),
      m && h.rotate((p * ne) / 180),
      f && h.scale(u, g),
      h.drawImage(t, ae(l), ae(c), ae(s), ae(d)),
      v && h.restore(),
      r
    );
  }
  function S(t, e, i) {
    var a = '',
      n = e;
    for (i += e; n < i; n++) a += ce(t.getUint8(n));
    return a;
  }
  function _(t) {
    var e,
      i,
      a,
      n,
      o,
      r,
      h,
      l,
      c,
      s,
      d = new DataView(t),
      p = d.byteLength;
    if (255 === d.getUint8(0) && 216 === d.getUint8(1))
      for (c = 2; c < p; ) {
        if (255 === d.getUint8(c) && 225 === d.getUint8(c + 1)) {
          h = c;
          break;
        }
        c++;
      }
    if (
      (h &&
        ((i = h + 4),
        (a = h + 10),
        'Exif' === S(d, i, 4) &&
          ((r = d.getUint16(a)),
          (o = 18761 === r),
          (o || 19789 === r) &&
            42 === d.getUint16(a + 2, o) &&
            ((n = d.getUint32(a + 4, o)), n >= 8 && (l = a + n)))),
      l)
    )
      for (p = d.getUint16(l, o), s = 0; s < p; s++)
        if (((c = l + 12 * s + 2), 274 === d.getUint16(c, o))) {
          (c += 8), (e = d.getUint16(c, o)), $t && d.setUint16(c, 1, o);
          break;
        }
    return e;
  }
  function P(t) {
    var e,
      i = t.replace(Wt, ''),
      a = atob(i),
      n = a.length,
      o = new $(n),
      r = new Uint8Array(o);
    for (e = 0; e < n; e++) r[e] = a.charCodeAt(e);
    return o;
  }
  function j(t) {
    var e,
      i = new Uint8Array(t),
      a = i.length,
      n = '';
    for (e = 0; e < a; e++) n += ce(i[e]);
    return 'data:image/jpeg;base64,' + btoa(n);
  }
  function q(t, e) {
    var i = this;
    (i.element = t),
      (i.options = p({}, q.DEFAULTS, r(e) && e)),
      (i.ready = !1),
      (i.built = !1),
      (i.complete = !1),
      (i.rotated = !1),
      (i.cropped = !1),
      (i.disabled = !1),
      (i.replaced = !1),
      (i.limited = !1),
      (i.wheeling = !1),
      (i.isImg = !1),
      (i.originalUrl = ''),
      (i.canvasData = null),
      (i.cropBoxData = null),
      (i.previews = null),
      i.init();
  }
  var F = t.document,
    V = t.location,
    Z = t.navigator,
    $ = t.ArrayBuffer,
    K = t.Object,
    G = t.Array,
    J = t.String,
    Q = t.Number,
    tt = t.Math,
    et = 'cropper',
    it = et + '-modal',
    at = et + '-hide',
    nt = et + '-hidden',
    ot = et + '-invisible',
    rt = et + '-move',
    ht = et + '-crop',
    lt = et + '-disabled',
    ct = et + '-bg',
    st = 'mousedown touchstart pointerdown MSPointerDown',
    dt = 'mousemove touchmove pointermove MSPointerMove',
    pt =
      'mouseup touchend touchcancel pointerup pointercancel MSPointerUp MSPointerCancel',
    ut = 'wheel mousewheel DOMMouseScroll',
    gt = 'dblclick',
    ft = 'resize',
    mt = 'error',
    vt = 'load',
    wt = 'build',
    bt = 'built',
    xt = 'cropstart',
    Dt = 'cropmove',
    Ct = 'cropend',
    yt = 'crop',
    Bt = 'zoom',
    Tt = /e|w|s|n|se|sw|ne|nw|all|crop|move|zoom/,
    Lt = /width|height|left|top|marginLeft|marginTop/,
    Xt = /^(https?:)\/\/([^\:\/\?#]+):?(\d*)/i,
    Yt = /^\s+(.*)\s+$/,
    kt = /\s+/,
    Et = /^data\:/,
    Wt = /^data\:([^\;]+)\;base64,/,
    Ht = /^data\:image\/jpeg.*;base64,/,
    Mt = 'preview',
    zt = 'action',
    Ot = 'e',
    Rt = 'w',
    Nt = 's',
    Ut = 'n',
    At = 'se',
    It = 'sw',
    St = 'ne',
    _t = 'nw',
    Pt = 'all',
    jt = 'crop',
    qt = 'move',
    Ft = 'zoom',
    Vt = 'none',
    Zt = !!F.createElement('canvas').getContext,
    $t = Z && /safari/i.test(Z.userAgent) && /apple computer/i.test(Z.vendor),
    Kt = tt.min,
    Gt = tt.max,
    Jt = tt.abs,
    Qt = tt.sin,
    te = tt.cos,
    ee = tt.sqrt,
    ie = tt.round,
    ae = tt.floor,
    ne = tt.PI,
    oe = K.prototype,
    re = oe.toString,
    he = oe.hasOwnProperty,
    le = G.prototype.slice,
    ce = J.fromCharCode;
  (q.prototype = {
    constructor: q,
    init: function () {
      var t,
        e = this,
        i = e.element,
        a = i.tagName.toLowerCase();
      if (!b(i, et)) {
        if ((x(i, et, e), 'img' === a)) {
          if (((e.isImg = !0), (e.originalUrl = t = i.getAttribute('src')), !t))
            return;
          t = i.src;
        } else 'canvas' === a && Zt && (t = i.toDataURL());
        e.load(t);
      }
    },
    load: function (t) {
      var e,
        i = this,
        a = i.options,
        n = i.element;
      if (t && (h(a.build) && y(n, wt, a.build, !0), B(n, wt) !== !1)) {
        if (((i.url = t), (i.imageData = {}), !a.checkOrientation || !$))
          return i.clone();
        if (Et.test(t)) return Ht.test(t) ? i.read(P(t)) : i.clone();
        (e = new XMLHttpRequest()),
          (e.onerror = e.onabort =
            function () {
              i.clone();
            }),
          (e.onload = function () {
            i.read(this.response);
          }),
          a.checkCrossOrigin && O(t) && n.crossOrigin && (t = R(t)),
          e.open('get', t),
          (e.responseType = 'arraybuffer'),
          e.send();
      }
    },
    read: function (t) {
      var e,
        i,
        a,
        n = this,
        o = n.options,
        r = _(t),
        h = n.imageData;
      if (r > 1)
        switch (((n.url = j(t)), r)) {
          case 2:
            i = -1;
            break;
          case 3:
            e = -180;
            break;
          case 4:
            a = -1;
            break;
          case 5:
            (e = 90), (a = -1);
            break;
          case 6:
            e = 90;
            break;
          case 7:
            (e = 90), (i = -1);
            break;
          case 8:
            e = -90;
        }
      o.rotatable && (h.rotate = e),
        o.scalable && ((h.scaleX = i), (h.scaleY = a)),
        n.clone();
    },
    clone: function () {
      var t,
        e,
        i,
        a,
        n,
        o = this,
        r = o.element,
        h = o.url;
      o.options.checkCrossOrigin &&
        O(h) &&
        ((t = r.crossOrigin), t ? (e = h) : ((t = 'anonymous'), (e = R(h)))),
        (o.crossOrigin = t),
        (o.crossOriginUrl = e),
        (i = W('img')),
        t && (i.crossOrigin = t),
        (i.src = e || h),
        (o.image = i),
        (o._start = a = u(o.start, o)),
        (o._stop = n = u(o.stop, o)),
        o.isImg
          ? r.complete
            ? o.start()
            : y(r, vt, a)
          : (y(i, vt, a),
            y(i, mt, n),
            m(i, at),
            r.parentNode.insertBefore(i, r.nextSibling));
    },
    start: function (t) {
      var e = this,
        i = e.isImg ? e.element : e.image;
      t && (C(i, vt, e._start), C(i, mt, e._stop)),
        N(i, function (t, i) {
          p(e.imageData, {
            naturalWidth: t,
            naturalHeight: i,
            aspectRatio: t / i
          }),
            (e.ready = !0),
            e.build();
        });
    },
    stop: function () {
      var t = this,
        e = t.image;
      C(e, vt, t._start), C(e, mt, t._stop), M(e), (t.image = null);
    },
    build: function () {
      var t,
        e,
        i,
        a,
        n,
        o,
        r,
        l = this,
        c = l.options,
        s = l.element,
        d = l.image;
      l.ready &&
        (l.built && l.unbuild(),
        (e = W('div')),
        (e.innerHTML = q.TEMPLATE),
        (l.container = t = s.parentNode),
        (l.cropper = i = E(e, 'cropper-container')[0]),
        (l.canvas = a = E(i, 'cropper-canvas')[0]),
        (l.dragBox = n = E(i, 'cropper-drag-box')[0]),
        (l.cropBox = o = E(i, 'cropper-crop-box')[0]),
        (l.viewBox = E(i, 'cropper-view-box')[0]),
        (l.face = r = E(o, 'cropper-face')[0]),
        H(a, d),
        m(s, nt),
        t.insertBefore(i, s.nextSibling),
        l.isImg || v(d, at),
        l.initPreview(),
        l.bind(),
        (c.aspectRatio = Gt(0, c.aspectRatio) || NaN),
        (c.viewMode = Gt(0, Kt(3, ie(c.viewMode))) || 0),
        c.autoCrop ? ((l.cropped = !0), c.modal && m(n, it)) : m(o, nt),
        c.guides || m(E(o, 'cropper-dashed'), nt),
        c.center || m(E(o, 'cropper-center'), nt),
        c.background && m(i, ct),
        c.highlight || m(r, ot),
        c.cropBoxMovable && (m(r, rt), x(r, zt, Pt)),
        c.cropBoxResizable ||
          (m(E(o, 'cropper-line'), nt), m(E(o, 'cropper-point'), nt)),
        l.setDragMode(c.dragMode),
        l.render(),
        (l.built = !0),
        l.setData(c.data),
        setTimeout(function () {
          h(c.built) && y(s, bt, c.built, !0),
            B(s, bt),
            B(s, yt, l.getData()),
            (l.complete = !0);
        }, 0));
    },
    unbuild: function () {
      var t = this;
      t.built &&
        ((t.built = !1),
        (t.complete = !1),
        (t.initialImageData = null),
        (t.initialCanvasData = null),
        (t.initialCropBoxData = null),
        (t.containerData = null),
        (t.canvasData = null),
        (t.cropBoxData = null),
        t.unbind(),
        t.resetPreview(),
        (t.previews = null),
        (t.viewBox = null),
        (t.cropBox = null),
        (t.dragBox = null),
        (t.canvas = null),
        (t.container = null),
        M(t.cropper),
        (t.cropper = null));
    },
    render: function () {
      var t = this;
      t.initContainer(),
        t.initCanvas(),
        t.initCropBox(),
        t.renderCanvas(),
        t.cropped && t.renderCropBox();
    },
    initContainer: function () {
      var t,
        e = this,
        i = e.options,
        a = e.element,
        n = e.container,
        o = e.cropper;
      m(o, nt),
        v(a, nt),
        (e.containerData = t =
          {
            width: Gt(n.offsetWidth, Q(i.minContainerWidth) || 200),
            height: Gt(n.offsetHeight, Q(i.minContainerHeight) || 100)
          }),
        g(o, { width: t.width, height: t.height }),
        m(a, nt),
        v(o, nt);
    },
    initCanvas: function () {
      var t,
        e = this,
        i = e.options.viewMode,
        a = e.containerData,
        n = e.imageData,
        o = 90 === Jt(n.rotate),
        r = o ? n.naturalHeight : n.naturalWidth,
        h = o ? n.naturalWidth : n.naturalHeight,
        l = r / h,
        c = a.width,
        s = a.height;
      a.height * l > a.width
        ? 3 === i
          ? (c = a.height * l)
          : (s = a.width / l)
        : 3 === i
        ? (s = a.width / l)
        : (c = a.height * l),
        (t = {
          naturalWidth: r,
          naturalHeight: h,
          aspectRatio: l,
          width: c,
          height: s
        }),
        (t.oldLeft = t.left = (a.width - c) / 2),
        (t.oldTop = t.top = (a.height - s) / 2),
        (e.canvasData = t),
        (e.limited = 1 === i || 2 === i),
        e.limitCanvas(!0, !0),
        (e.initialImageData = p({}, n)),
        (e.initialCanvasData = p({}, t));
    },
    limitCanvas: function (t, e) {
      var i,
        a,
        n,
        o,
        r = this,
        h = r.options,
        l = h.viewMode,
        c = r.containerData,
        s = r.canvasData,
        d = s.aspectRatio,
        p = r.cropBoxData,
        u = r.cropped && p;
      t &&
        ((i = Q(h.minCanvasWidth) || 0),
        (a = Q(h.minCanvasHeight) || 0),
        l > 1
          ? ((i = Gt(i, c.width)),
            (a = Gt(a, c.height)),
            3 === l && (a * d > i ? (i = a * d) : (a = i / d)))
          : l > 0 &&
            (i
              ? (i = Gt(i, u ? p.width : 0))
              : a
              ? (a = Gt(a, u ? p.height : 0))
              : u &&
                ((i = p.width),
                (a = p.height),
                a * d > i ? (i = a * d) : (a = i / d))),
        i && a
          ? a * d > i
            ? (a = i / d)
            : (i = a * d)
          : i
          ? (a = i / d)
          : a && (i = a * d),
        (s.minWidth = i),
        (s.minHeight = a),
        (s.maxWidth = 1 / 0),
        (s.maxHeight = 1 / 0)),
        e &&
          (l
            ? ((n = c.width - s.width),
              (o = c.height - s.height),
              (s.minLeft = Kt(0, n)),
              (s.minTop = Kt(0, o)),
              (s.maxLeft = Gt(0, n)),
              (s.maxTop = Gt(0, o)),
              u &&
                r.limited &&
                ((s.minLeft = Kt(p.left, p.left + p.width - s.width)),
                (s.minTop = Kt(p.top, p.top + p.height - s.height)),
                (s.maxLeft = p.left),
                (s.maxTop = p.top),
                2 === l &&
                  (s.width >= c.width &&
                    ((s.minLeft = Kt(0, n)), (s.maxLeft = Gt(0, n))),
                  s.height >= c.height &&
                    ((s.minTop = Kt(0, o)), (s.maxTop = Gt(0, o))))))
            : ((s.minLeft = -s.width),
              (s.minTop = -s.height),
              (s.maxLeft = c.width),
              (s.maxTop = c.height)));
    },
    renderCanvas: function (t) {
      var e,
        i,
        a = this,
        n = a.canvasData,
        o = a.imageData,
        r = o.rotate;
      a.rotated &&
        ((a.rotated = !1),
        (i = A({ width: o.width, height: o.height, degree: r })),
        (e = i.width / i.height),
        e !== n.aspectRatio &&
          ((n.left -= (i.width - n.width) / 2),
          (n.top -= (i.height - n.height) / 2),
          (n.width = i.width),
          (n.height = i.height),
          (n.aspectRatio = e),
          (n.naturalWidth = o.naturalWidth),
          (n.naturalHeight = o.naturalHeight),
          r % 180 &&
            ((i = A({
              width: o.naturalWidth,
              height: o.naturalHeight,
              degree: r
            })),
            (n.naturalWidth = i.width),
            (n.naturalHeight = i.height)),
          a.limitCanvas(!0, !1))),
        (n.width > n.maxWidth || n.width < n.minWidth) && (n.left = n.oldLeft),
        (n.height > n.maxHeight || n.height < n.minHeight) &&
          (n.top = n.oldTop),
        (n.width = Kt(Gt(n.width, n.minWidth), n.maxWidth)),
        (n.height = Kt(Gt(n.height, n.minHeight), n.maxHeight)),
        a.limitCanvas(!1, !0),
        (n.oldLeft = n.left = Kt(Gt(n.left, n.minLeft), n.maxLeft)),
        (n.oldTop = n.top = Kt(Gt(n.top, n.minTop), n.maxTop)),
        g(a.canvas, {
          width: n.width,
          height: n.height,
          left: n.left,
          top: n.top
        }),
        a.renderImage(),
        a.cropped && a.limited && a.limitCropBox(!0, !0),
        t && a.output();
    },
    renderImage: function (t) {
      var e,
        i,
        a,
        n,
        o,
        r = this,
        h = r.canvasData,
        l = r.imageData;
      l.rotate &&
        ((i = A(
          {
            width: h.width,
            height: h.height,
            degree: l.rotate,
            aspectRatio: l.aspectRatio
          },
          !0
        )),
        (a = i.width),
        (n = i.height),
        (e = {
          width: a,
          height: n,
          left: (h.width - a) / 2,
          top: (h.height - n) / 2
        })),
        p(l, e || { width: h.width, height: h.height, left: 0, top: 0 }),
        (o = U(l)),
        g(r.image, {
          width: l.width,
          height: l.height,
          marginLeft: l.left,
          marginTop: l.top,
          WebkitTransform: o,
          msTransform: o,
          transform: o
        }),
        t && r.output();
    },
    initCropBox: function () {
      var t = this,
        e = t.options,
        i = e.aspectRatio,
        a = Q(e.autoCropArea) || 0.8,
        n = t.canvasData,
        o = { width: n.width, height: n.height };
      i &&
        (n.height * i > n.width
          ? (o.height = o.width / i)
          : (o.width = o.height * i)),
        (t.cropBoxData = o),
        t.limitCropBox(!0, !0),
        (o.width = Kt(Gt(o.width, o.minWidth), o.maxWidth)),
        (o.height = Kt(Gt(o.height, o.minHeight), o.maxHeight)),
        (o.width = Gt(o.minWidth, o.width * a)),
        (o.height = Gt(o.minHeight, o.height * a)),
        (o.oldLeft = o.left = n.left + (n.width - o.width) / 2),
        (o.oldTop = o.top = n.top + (n.height - o.height) / 2),
        (t.initialCropBoxData = p({}, o));
    },
    limitCropBox: function (t, e) {
      var i,
        a,
        n,
        o,
        r = this,
        h = r.options,
        l = h.aspectRatio,
        c = r.containerData,
        s = r.canvasData,
        d = r.cropBoxData,
        p = r.limited;
      t &&
        ((i = Q(h.minCropBoxWidth) || 0),
        (a = Q(h.minCropBoxHeight) || 0),
        (i = Kt(i, c.width)),
        (a = Kt(a, c.height)),
        (n = Kt(c.width, p ? s.width : c.width)),
        (o = Kt(c.height, p ? s.height : c.height)),
        l &&
          (i && a
            ? a * l > i
              ? (a = i / l)
              : (i = a * l)
            : i
            ? (a = i / l)
            : a && (i = a * l),
          o * l > n ? (o = n / l) : (n = o * l)),
        (d.minWidth = Kt(i, n)),
        (d.minHeight = Kt(a, o)),
        (d.maxWidth = n),
        (d.maxHeight = o)),
        e &&
          (p
            ? ((d.minLeft = Gt(0, s.left)),
              (d.minTop = Gt(0, s.top)),
              (d.maxLeft = Kt(c.width, s.left + s.width) - d.width),
              (d.maxTop = Kt(c.height, s.top + s.height) - d.height))
            : ((d.minLeft = 0),
              (d.minTop = 0),
              (d.maxLeft = c.width - d.width),
              (d.maxTop = c.height - d.height)));
    },
    renderCropBox: function () {
      var t = this,
        e = t.options,
        i = t.containerData,
        a = t.cropBoxData;
      (a.width > a.maxWidth || a.width < a.minWidth) && (a.left = a.oldLeft),
        (a.height > a.maxHeight || a.height < a.minHeight) &&
          (a.top = a.oldTop),
        (a.width = Kt(Gt(a.width, a.minWidth), a.maxWidth)),
        (a.height = Kt(Gt(a.height, a.minHeight), a.maxHeight)),
        t.limitCropBox(!1, !0),
        (a.oldLeft = a.left = Kt(Gt(a.left, a.minLeft), a.maxLeft)),
        (a.oldTop = a.top = Kt(Gt(a.top, a.minTop), a.maxTop)),
        e.movable &&
          e.cropBoxMovable &&
          x(t.face, zt, a.width === i.width && a.height === i.height ? qt : Pt),
        g(t.cropBox, {
          width: a.width,
          height: a.height,
          left: a.left,
          top: a.top
        }),
        t.cropped && t.limited && t.limitCanvas(!0, !0),
        t.disabled || t.output();
    },
    output: function () {
      var t = this;
      t.preview(), t.complete && B(t.element, yt, t.getData());
    },
    initPreview: function () {
      var t,
        e = this,
        i = e.options.preview,
        a = W('img'),
        n = e.crossOrigin,
        o = n ? e.crossOriginUrl : e.url;
      n && (a.crossOrigin = n),
        (a.src = o),
        H(e.viewBox, a),
        (e.image2 = a),
        i &&
          ((e.previews = t = F.querySelectorAll(i)),
          d(t, function (t) {
            var e = W('img');
            x(t, Mt, {
              width: t.offsetWidth,
              height: t.offsetHeight,
              html: t.innerHTML
            }),
              n && (e.crossOrigin = n),
              (e.src = o),
              (e.style.cssText =
                'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"'),
              z(t),
              H(t, e);
          }));
    },
    resetPreview: function () {
      d(this.previews, function (t) {
        var e = b(t, Mt);
        g(t, { width: e.width, height: e.height }),
          (t.innerHTML = e.html),
          D(t, Mt);
      });
    },
    preview: function () {
      var t = this,
        e = t.imageData,
        i = t.canvasData,
        a = t.cropBoxData,
        n = a.width,
        o = a.height,
        r = e.width,
        h = e.height,
        l = a.left - i.left - e.left,
        c = a.top - i.top - e.top,
        s = U(e),
        u = { WebkitTransform: s, msTransform: s, transform: s };
      t.cropped &&
        !t.disabled &&
        (g(
          t.image2,
          p({ width: r, height: h, marginLeft: -l, marginTop: -c }, u)
        ),
        d(t.previews, function (t) {
          var e = b(t, Mt),
            i = e.width,
            a = e.height,
            s = i,
            d = a,
            f = 1;
          n && ((f = i / n), (d = o * f)),
            o && d > a && ((f = a / o), (s = n * f), (d = a)),
            g(t, { width: s, height: d }),
            g(
              k(t, 'img')[0],
              p(
                {
                  width: r * f,
                  height: h * f,
                  marginLeft: -l * f,
                  marginTop: -c * f
                },
                u
              )
            );
        }));
    },
    bind: function () {
      var e = this,
        i = e.options,
        a = e.element,
        n = e.cropper;
      h(i.cropstart) && y(a, xt, i.cropstart),
        h(i.cropmove) && y(a, Dt, i.cropmove),
        h(i.cropend) && y(a, Ct, i.cropend),
        h(i.crop) && y(a, yt, i.crop),
        h(i.zoom) && y(a, Bt, i.zoom),
        y(n, st, (e._cropStart = u(e.cropStart, e))),
        i.zoomable && i.zoomOnWheel && y(n, ut, (e._wheel = u(e.wheel, e))),
        i.toggleDragModeOnDblclick &&
          y(n, gt, (e._dblclick = u(e.dblclick, e))),
        y(F, dt, (e._cropMove = u(e.cropMove, e))),
        y(F, pt, (e._cropEnd = u(e.cropEnd, e))),
        i.responsive && y(t, ft, (e._resize = u(e.resize, e)));
    },
    unbind: function () {
      var e = this,
        i = e.options,
        a = e.element,
        n = e.cropper;
      h(i.cropstart) && C(a, xt, i.cropstart),
        h(i.cropmove) && C(a, Dt, i.cropmove),
        h(i.cropend) && C(a, Ct, i.cropend),
        h(i.crop) && C(a, yt, i.crop),
        h(i.zoom) && C(a, Bt, i.zoom),
        C(n, st, e._cropStart),
        i.zoomable && i.zoomOnWheel && C(n, ut, e._wheel),
        i.toggleDragModeOnDblclick && C(n, gt, e._dblclick),
        C(F, dt, e._cropMove),
        C(F, pt, e._cropEnd),
        i.responsive && C(t, ft, e._resize);
    },
    resize: function () {
      var t,
        e,
        i,
        a = this,
        n = a.options.restore,
        o = a.container,
        r = a.containerData;
      !a.disabled &&
        r &&
        ((i = o.offsetWidth / r.width),
        (1 === i && o.offsetHeight === r.height) ||
          (n && ((t = a.getCanvasData()), (e = a.getCropBoxData())),
          a.render(),
          n &&
            (a.setCanvasData(
              d(t, function (e, a) {
                t[a] = e * i;
              })
            ),
            a.setCropBoxData(
              d(e, function (t, a) {
                e[a] = t * i;
              })
            ))));
    },
    dblclick: function () {
      var t = this;
      t.disabled || t.setDragMode(f(t.dragBox, ht) ? qt : jt);
    },
    wheel: function (t) {
      var e = this,
        i = L(t),
        a = Q(e.options.wheelZoomRatio) || 0.1,
        n = 1;
      e.disabled ||
        (T(i),
        e.wheeling ||
          ((e.wheeling = !0),
          setTimeout(function () {
            e.wheeling = !1;
          }, 50),
          i.deltaY
            ? (n = i.deltaY > 0 ? 1 : -1)
            : i.wheelDelta
            ? (n = -i.wheelDelta / 120)
            : i.detail && (n = i.detail > 0 ? 1 : -1),
          e.zoom(-n * a, i)));
    },
    cropStart: function (t) {
      var e,
        i,
        a,
        n = this,
        o = n.options,
        r = L(t),
        h = r.touches;
      if (!n.disabled) {
        if (h) {
          if (((e = h.length), e > 1)) {
            if (!o.zoomable || !o.zoomOnTouch || 2 !== e) return;
            (i = h[1]), (n.startX2 = i.pageX), (n.startY2 = i.pageY), (a = Ft);
          }
          i = h[0];
        }
        if (((a = a || b(r.target, zt)), Tt.test(a))) {
          if (B(n.element, xt, { originalEvent: r, action: a }) === !1) return;
          T(r),
            (n.action = a),
            (n.cropping = !1),
            (n.startX = i ? i.pageX : r.pageX),
            (n.startY = i ? i.pageY : r.pageY),
            a === jt && ((n.cropping = !0), m(n.dragBox, it));
        }
      }
    },
    cropMove: function (t) {
      var e,
        i,
        a = this,
        n = a.options,
        o = L(t),
        r = o.touches,
        h = a.action;
      if (!a.disabled) {
        if (r) {
          if (((e = r.length), e > 1)) {
            if (!n.zoomable || !n.zoomOnTouch || 2 !== e) return;
            (i = r[1]), (a.endX2 = i.pageX), (a.endY2 = i.pageY);
          }
          i = r[0];
        }
        if (h) {
          if (B(a.element, Dt, { originalEvent: o, action: h }) === !1) return;
          T(o),
            (a.endX = i ? i.pageX : o.pageX),
            (a.endY = i ? i.pageY : o.pageY),
            a.change(o.shiftKey, h === Ft ? o : null);
        }
      }
    },
    cropEnd: function (t) {
      var e = this,
        i = e.options,
        a = L(t),
        n = e.action;
      e.disabled ||
        (n &&
          (T(a),
          e.cropping &&
            ((e.cropping = !1), w(e.dragBox, it, e.cropped && i.modal)),
          (e.action = ''),
          B(e.element, Ct, { originalEvent: a, action: n })));
    },
    change: function (t, e) {
      var i,
        a,
        n = this,
        o = n.options,
        r = o.aspectRatio,
        h = n.action,
        l = n.containerData,
        c = n.canvasData,
        s = n.cropBoxData,
        d = s.width,
        p = s.height,
        u = s.left,
        g = s.top,
        f = u + d,
        m = g + p,
        w = 0,
        b = 0,
        x = l.width,
        D = l.height,
        C = !0;
      switch (
        (!r && t && (r = d && p ? d / p : 1),
        n.limited &&
          ((w = s.minLeft),
          (b = s.minTop),
          (x = w + Kt(l.width, c.left + c.width)),
          (D = b + Kt(l.height, c.top + c.height))),
        (a = { x: n.endX - n.startX, y: n.endY - n.startY }),
        r && ((a.X = a.y * r), (a.Y = a.x / r)),
        h)
      ) {
        case Pt:
          (u += a.x), (g += a.y);
          break;
        case Ot:
          if (a.x >= 0 && (f >= x || (r && (g <= b || m >= D)))) {
            C = !1;
            break;
          }
          (d += a.x),
            r && ((p = d / r), (g -= a.Y / 2)),
            d < 0 && ((h = Rt), (d = 0));
          break;
        case Ut:
          if (a.y <= 0 && (g <= b || (r && (u <= w || f >= x)))) {
            C = !1;
            break;
          }
          (p -= a.y),
            (g += a.y),
            r && ((d = p * r), (u += a.X / 2)),
            p < 0 && ((h = Nt), (p = 0));
          break;
        case Rt:
          if (a.x <= 0 && (u <= w || (r && (g <= b || m >= D)))) {
            C = !1;
            break;
          }
          (d -= a.x),
            (u += a.x),
            r && ((p = d / r), (g += a.Y / 2)),
            d < 0 && ((h = Ot), (d = 0));
          break;
        case Nt:
          if (a.y >= 0 && (m >= D || (r && (u <= w || f >= x)))) {
            C = !1;
            break;
          }
          (p += a.y),
            r && ((d = p * r), (u -= a.X / 2)),
            p < 0 && ((h = Ut), (p = 0));
          break;
        case St:
          if (r) {
            if (a.y <= 0 && (g <= b || f >= x)) {
              C = !1;
              break;
            }
            (p -= a.y), (g += a.y), (d = p * r);
          } else
            a.x >= 0
              ? f < x
                ? (d += a.x)
                : a.y <= 0 && g <= b && (C = !1)
              : (d += a.x),
              a.y <= 0
                ? g > b && ((p -= a.y), (g += a.y))
                : ((p -= a.y), (g += a.y));
          d < 0 && p < 0
            ? ((h = It), (p = 0), (d = 0))
            : d < 0
            ? ((h = _t), (d = 0))
            : p < 0 && ((h = At), (p = 0));
          break;
        case _t:
          if (r) {
            if (a.y <= 0 && (g <= b || u <= w)) {
              C = !1;
              break;
            }
            (p -= a.y), (g += a.y), (d = p * r), (u += a.X);
          } else
            a.x <= 0
              ? u > w
                ? ((d -= a.x), (u += a.x))
                : a.y <= 0 && g <= b && (C = !1)
              : ((d -= a.x), (u += a.x)),
              a.y <= 0
                ? g > b && ((p -= a.y), (g += a.y))
                : ((p -= a.y), (g += a.y));
          d < 0 && p < 0
            ? ((h = At), (p = 0), (d = 0))
            : d < 0
            ? ((h = St), (d = 0))
            : p < 0 && ((h = It), (p = 0));
          break;
        case It:
          if (r) {
            if (a.x <= 0 && (u <= w || m >= D)) {
              C = !1;
              break;
            }
            (d -= a.x), (u += a.x), (p = d / r);
          } else
            a.x <= 0
              ? u > w
                ? ((d -= a.x), (u += a.x))
                : a.y >= 0 && m >= D && (C = !1)
              : ((d -= a.x), (u += a.x)),
              a.y >= 0 ? m < D && (p += a.y) : (p += a.y);
          d < 0 && p < 0
            ? ((h = St), (p = 0), (d = 0))
            : d < 0
            ? ((h = At), (d = 0))
            : p < 0 && ((h = _t), (p = 0));
          break;
        case At:
          if (r) {
            if (a.x >= 0 && (f >= x || m >= D)) {
              C = !1;
              break;
            }
            (d += a.x), (p = d / r);
          } else
            a.x >= 0
              ? f < x
                ? (d += a.x)
                : a.y >= 0 && m >= D && (C = !1)
              : (d += a.x),
              a.y >= 0 ? m < D && (p += a.y) : (p += a.y);
          d < 0 && p < 0
            ? ((h = _t), (p = 0), (d = 0))
            : d < 0
            ? ((h = It), (d = 0))
            : p < 0 && ((h = St), (p = 0));
          break;
        case qt:
          n.move(a.x, a.y), (C = !1);
          break;
        case Ft:
          n.zoom(
            (function (t, e, i, a) {
              var n = ee(t * t + e * e),
                o = ee(i * i + a * a);
              return (o - n) / n;
            })(
              Jt(n.startX - n.startX2),
              Jt(n.startY - n.startY2),
              Jt(n.endX - n.endX2),
              Jt(n.endY - n.endY2)
            ),
            e
          ),
            (n.startX2 = n.endX2),
            (n.startY2 = n.endY2),
            (C = !1);
          break;
        case jt:
          if (!a.x || !a.y) {
            C = !1;
            break;
          }
          (i = X(n.cropper)),
            (u = n.startX - i.left),
            (g = n.startY - i.top),
            (d = s.minWidth),
            (p = s.minHeight),
            a.x > 0
              ? (h = a.y > 0 ? At : St)
              : a.x < 0 && ((u -= d), (h = a.y > 0 ? It : _t)),
            a.y < 0 && (g -= p),
            n.cropped ||
              (v(n.cropBox, nt),
              (n.cropped = !0),
              n.limited && n.limitCropBox(!0, !0));
      }
      C &&
        ((s.width = d),
        (s.height = p),
        (s.left = u),
        (s.top = g),
        (n.action = h),
        n.renderCropBox()),
        (n.startX = n.endX),
        (n.startY = n.endY);
    },
    crop: function () {
      var t = this;
      return (
        t.built &&
          !t.disabled &&
          (t.cropped ||
            ((t.cropped = !0),
            t.limitCropBox(!0, !0),
            t.options.modal && m(t.dragBox, it),
            v(t.cropBox, nt)),
          t.setCropBoxData(t.initialCropBoxData)),
        t
      );
    },
    reset: function () {
      var t = this;
      return (
        t.built &&
          !t.disabled &&
          ((t.imageData = p({}, t.initialImageData)),
          (t.canvasData = p({}, t.initialCanvasData)),
          (t.cropBoxData = p({}, t.initialCropBoxData)),
          t.renderCanvas(),
          t.cropped && t.renderCropBox()),
        t
      );
    },
    clear: function () {
      var t = this;
      return (
        t.cropped &&
          !t.disabled &&
          (p(t.cropBoxData, { left: 0, top: 0, width: 0, height: 0 }),
          (t.cropped = !1),
          t.renderCropBox(),
          t.limitCanvas(),
          t.renderCanvas(),
          v(t.dragBox, it),
          m(t.cropBox, nt)),
        t
      );
    },
    replace: function (t, e) {
      var i = this;
      return (
        !i.disabled &&
          t &&
          (i.isImg && (i.element.src = t),
          e
            ? ((i.url = t),
              (i.image.src = t),
              i.built &&
                ((i.image2.src = t),
                d(i.previews, function (e) {
                  k(e, 'img')[0].src = t;
                })))
            : (i.isImg && (i.replaced = !0),
              (i.options.data = null),
              i.load(t))),
        i
      );
    },
    enable: function () {
      var t = this;
      return t.built && ((t.disabled = !1), v(t.cropper, lt)), t;
    },
    disable: function () {
      var t = this;
      return t.built && ((t.disabled = !0), m(t.cropper, lt)), t;
    },
    destroy: function () {
      var t = this,
        e = t.element,
        i = t.image;
      return (
        t.ready
          ? (t.isImg && t.replaced && (e.src = t.originalUrl),
            t.unbuild(),
            v(e, nt))
          : t.isImg
          ? C(e, vt, t.start)
          : i && M(i),
        D(e, et),
        t
      );
    },
    move: function (t, e) {
      var i = this,
        a = i.canvasData;
      return i.moveTo(n(t) ? t : a.left + Q(t), n(e) ? e : a.top + Q(e));
    },
    moveTo: function (t, e) {
      var i = this,
        o = i.canvasData,
        r = !1;
      return (
        n(e) && (e = t),
        (t = Q(t)),
        (e = Q(e)),
        i.built &&
          !i.disabled &&
          i.options.movable &&
          (a(t) && ((o.left = t), (r = !0)),
          a(e) && ((o.top = e), (r = !0)),
          r && i.renderCanvas(!0)),
        i
      );
    },
    zoom: function (t, e) {
      var i = this,
        a = i.canvasData;
      return (
        (t = Q(t)),
        (t = t < 0 ? 1 / (1 - t) : 1 + t),
        i.zoomTo((a.width * t) / a.naturalWidth, e)
      );
    },
    zoomTo: function (t, e) {
      var i,
        a,
        n,
        o,
        r = this,
        h = r.options,
        l = r.canvasData,
        c = l.width,
        s = l.height,
        d = l.naturalWidth,
        p = l.naturalHeight;
      if (((t = Q(t)), t >= 0 && r.built && !r.disabled && h.zoomable)) {
        if (
          ((i = d * t),
          (a = p * t),
          B(r.element, Bt, {
            originalEvent: e,
            oldRatio: c / d,
            ratio: i / d
          }) === !1)
        )
          return r;
        e
          ? ((n = X(r.cropper)),
            (o = e.touches ? Y(e.touches) : { pageX: e.pageX, pageY: e.pageY }),
            (l.left -= (i - c) * ((o.pageX - n.left - l.left) / c)),
            (l.top -= (a - s) * ((o.pageY - n.top - l.top) / s)))
          : ((l.left -= (i - c) / 2), (l.top -= (a - s) / 2)),
          (l.width = i),
          (l.height = a),
          r.renderCanvas(!0);
      }
      return r;
    },
    rotate: function (t) {
      var e = this;
      return e.rotateTo((e.imageData.rotate || 0) + Q(t));
    },
    rotateTo: function (t) {
      var e = this;
      return (
        (t = Q(t)),
        a(t) &&
          e.built &&
          !e.disabled &&
          e.options.rotatable &&
          ((e.imageData.rotate = t % 360),
          (e.rotated = !0),
          e.renderCanvas(!0)),
        e
      );
    },
    scale: function (t, e) {
      var i = this,
        o = i.imageData,
        r = !1;
      return (
        n(e) && (e = t),
        (t = Q(t)),
        (e = Q(e)),
        i.built &&
          !i.disabled &&
          i.options.scalable &&
          (a(t) && ((o.scaleX = t), (r = !0)),
          a(e) && ((o.scaleY = e), (r = !0)),
          r && i.renderImage(!0)),
        i
      );
    },
    scaleX: function (t) {
      var e = this,
        i = e.imageData.scaleY;
      return e.scale(t, a(i) ? i : 1);
    },
    scaleY: function (t) {
      var e = this,
        i = e.imageData.scaleX;
      return e.scale(a(i) ? i : 1, t);
    },
    getData: function (t) {
      var e,
        i,
        a = this,
        n = a.options,
        o = a.imageData,
        r = a.canvasData,
        h = a.cropBoxData;
      return (
        a.built && a.cropped
          ? ((i = {
              x: h.left - r.left,
              y: h.top - r.top,
              width: h.width,
              height: h.height
            }),
            (e = o.width / o.naturalWidth),
            d(i, function (a, n) {
              (a /= e), (i[n] = t ? ie(a) : a);
            }))
          : (i = { x: 0, y: 0, width: 0, height: 0 }),
        n.rotatable && (i.rotate = o.rotate || 0),
        n.scalable && ((i.scaleX = o.scaleX || 1), (i.scaleY = o.scaleY || 1)),
        i
      );
    },
    setData: function (t) {
      var e,
        i,
        n,
        o = this,
        l = o.options,
        c = o.imageData,
        s = o.canvasData,
        d = {};
      return (
        h(t) && (t = t.call(o.element)),
        o.built &&
          !o.disabled &&
          r(t) &&
          (l.rotatable &&
            a(t.rotate) &&
            t.rotate !== c.rotate &&
            ((c.rotate = t.rotate), (o.rotated = e = !0)),
          l.scalable &&
            (a(t.scaleX) &&
              t.scaleX !== c.scaleX &&
              ((c.scaleX = t.scaleX), (i = !0)),
            a(t.scaleY) &&
              t.scaleY !== c.scaleY &&
              ((c.scaleY = t.scaleY), (i = !0))),
          e ? o.renderCanvas() : i && o.renderImage(),
          (n = c.width / c.naturalWidth),
          a(t.x) && (d.left = t.x * n + s.left),
          a(t.y) && (d.top = t.y * n + s.top),
          a(t.width) && (d.width = t.width * n),
          a(t.height) && (d.height = t.height * n),
          o.setCropBoxData(d)),
        o
      );
    },
    getContainerData: function () {
      var t = this;
      return t.built ? t.containerData : {};
    },
    getImageData: function () {
      var t = this;
      return t.ready ? t.imageData : {};
    },
    getCanvasData: function () {
      var t = this,
        e = t.canvasData,
        i = {};
      return (
        t.built &&
          d(
            ['left', 'top', 'width', 'height', 'naturalWidth', 'naturalHeight'],
            function (t) {
              i[t] = e[t];
            }
          ),
        i
      );
    },
    setCanvasData: function (t) {
      var e = this,
        i = e.canvasData,
        n = i.aspectRatio;
      return (
        h(t) && (t = t.call(e.element)),
        e.built &&
          !e.disabled &&
          r(t) &&
          (a(t.left) && (i.left = t.left),
          a(t.top) && (i.top = t.top),
          a(t.width)
            ? ((i.width = t.width), (i.height = t.width / n))
            : a(t.height) && ((i.height = t.height), (i.width = t.height * n)),
          e.renderCanvas(!0)),
        e
      );
    },
    getCropBoxData: function () {
      var t,
        e = this,
        i = e.cropBoxData;
      return (
        e.built &&
          e.cropped &&
          (t = { left: i.left, top: i.top, width: i.width, height: i.height }),
        t || {}
      );
    },
    setCropBoxData: function (t) {
      var e,
        i,
        n = this,
        o = n.cropBoxData,
        l = n.options.aspectRatio;
      return (
        h(t) && (t = t.call(n.element)),
        n.built &&
          n.cropped &&
          !n.disabled &&
          r(t) &&
          (a(t.left) && (o.left = t.left),
          a(t.top) && (o.top = t.top),
          a(t.width) && ((e = !0), (o.width = t.width)),
          a(t.height) && ((i = !0), (o.height = t.height)),
          l && (e ? (o.height = o.width / l) : i && (o.width = o.height * l)),
          n.renderCropBox()),
        n
      );
    },
    getCroppedCanvas: function (t) {
      var e,
        i,
        a,
        n,
        o,
        h,
        l,
        c,
        s,
        d,
        p,
        u = this;
      if (u.built && Zt)
        return u.cropped
          ? (r(t) || (t = {}),
            (p = u.getData()),
            (e = p.width),
            (i = p.height),
            (c = e / i),
            r(t) &&
              ((o = t.width),
              (h = t.height),
              o ? ((h = o / c), (l = o / e)) : h && ((o = h * c), (l = h / i))),
            (a = ae(o || e)),
            (n = ae(h || i)),
            (s = W('canvas')),
            (s.width = a),
            (s.height = n),
            (d = s.getContext('2d')),
            t.fillColor &&
              ((d.fillStyle = t.fillColor), d.fillRect(0, 0, a, n)),
            d.drawImage.apply(
              d,
              function () {
                var t,
                  a,
                  n,
                  o,
                  r,
                  h,
                  c = I(u.image, u.imageData),
                  s = c.width,
                  d = c.height,
                  g = u.canvasData,
                  f = [c],
                  m = p.x + (g.naturalWidth * (Jt(p.scaleX || 1) - 1)) / 2,
                  v = p.y + (g.naturalHeight * (Jt(p.scaleY || 1) - 1)) / 2;
                return (
                  m <= -e || m > s
                    ? (m = t = n = r = 0)
                    : m <= 0
                    ? ((n = -m), (m = 0), (t = r = Kt(s, e + m)))
                    : m <= s && ((n = 0), (t = r = Kt(e, s - m))),
                  t <= 0 || v <= -i || v > d
                    ? (v = a = o = h = 0)
                    : v <= 0
                    ? ((o = -v), (v = 0), (a = h = Kt(d, i + v)))
                    : v <= d && ((o = 0), (a = h = Kt(i, d - v))),
                  f.push(ae(m), ae(v), ae(t), ae(a)),
                  l && ((n *= l), (o *= l), (r *= l), (h *= l)),
                  r > 0 && h > 0 && f.push(ae(n), ae(o), ae(r), ae(h)),
                  f
                );
              }.call(u)
            ),
            s)
          : I(u.image, u.imageData);
    },
    setAspectRatio: function (t) {
      var e = this,
        i = e.options;
      return (
        e.disabled ||
          n(t) ||
          ((i.aspectRatio = Gt(0, t) || NaN),
          e.built && (e.initCropBox(), e.cropped && e.renderCropBox())),
        e
      );
    },
    setDragMode: function (t) {
      var e,
        i,
        a = this,
        n = a.options,
        o = a.dragBox,
        r = a.face;
      return (
        a.ready &&
          !a.disabled &&
          ((e = t === jt),
          (i = n.movable && t === qt),
          (t = e || i ? t : Vt),
          x(o, zt, t),
          w(o, ht, e),
          w(o, rt, i),
          n.cropBoxMovable || (x(r, zt, t), w(r, ht, e), w(r, rt, i))),
        a
      );
    }
  }),
    (q.DEFAULTS = {
      viewMode: 0,
      dragMode: 'crop',
      aspectRatio: NaN,
      data: null,
      preview: '',
      responsive: !0,
      restore: !0,
      checkCrossOrigin: !0,
      checkOrientation: !0,
      modal: !0,
      guides: !0,
      center: !0,
      highlight: !0,
      background: !0,
      autoCrop: !0,
      autoCropArea: 0.8,
      movable: !0,
      rotatable: !0,
      scalable: !0,
      zoomable: !0,
      zoomOnTouch: !0,
      zoomOnWheel: !0,
      wheelZoomRatio: 0.1,
      cropBoxMovable: !0,
      cropBoxResizable: !0,
      toggleDragModeOnDblclick: !0,
      minCanvasWidth: 0,
      minCanvasHeight: 0,
      minCropBoxWidth: 0,
      minCropBoxHeight: 0,
      minContainerWidth: 200,
      minContainerHeight: 100,
      build: null,
      built: null,
      cropstart: null,
      cropmove: null,
      cropend: null,
      crop: null,
      zoom: null
    }),
    (q.TEMPLATE = (function (t, e) {
      return (
        (e = e.split(',')),
        t.replace(/\d+/g, function (t) {
          return e[t];
        })
      );
    })(
      '<0 6="5-container"><0 6="5-wrap-9"><0 6="5-canvas"></0></0><0 6="5-drag-9"></0><0 6="5-crop-9"><1 6="5-view-9"></1><1 6="5-8 8-h"></1><1 6="5-8 8-v"></1><1 6="5-center"></1><1 6="5-face"></1><1 6="5-7 7-e" 3-2="e"></1><1 6="5-7 7-n" 3-2="n"></1><1 6="5-7 7-w" 3-2="w"></1><1 6="5-7 7-s" 3-2="s"></1><1 6="5-4 4-e" 3-2="e"></1><1 6="5-4 4-n" 3-2="n"></1><1 6="5-4 4-w" 3-2="w"></1><1 6="5-4 4-s" 3-2="s"></1><1 6="5-4 4-ne" 3-2="ne"></1><1 6="5-4 4-nw" 3-2="nw"></1><1 6="5-4 4-sw" 3-2="sw"></1><1 6="5-4 4-se" 3-2="se"></1></0></0>',
      'div,span,action,data,point,cropper,class,line,dashed,box'
    ));
  var se = t.Cropper;
  return (
    (q.noConflict = function () {
      return (t.Cropper = se), q;
    }),
    (q.setDefaults = function (t) {
      p(q.DEFAULTS, t);
    }),
    'function' == typeof define &&
      define.amd &&
      define('cropper', [], function () {
        return q;
      }),
    e || (t.Cropper = q),
    q
  );
});
